import { render } from "./VoucherCodeSheet.vue?vue&type=template&id=7a22125a&scoped=true"
import script from "./VoucherCodeSheet.vue?vue&type=script&lang=js"
export * from "./VoucherCodeSheet.vue?vue&type=script&lang=js"

import "./VoucherCodeSheet.vue?vue&type=style&index=0&id=7a22125a&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a22125a"]])

export default __exports__